/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'ptc.pm.collaborators.title': 'Dine samarbejdspartnere',
  'ptc.pm.error-heading': 'Noget gik galt',
  'ptc.pm.error-image-alt-text':
    'En robot, der er gået i stykker, og en masse mennesker, der har travlt med at reparere den.',
  'ptc.pm.error-text': 'Vi holder øje med disse fejl, men kontakt os endelig, hvis det ikke hjælper at opdatere siden',
  'ptc.pm.num-members':
    '{memberCount, plural, one {{memberCount,number} medlem} other {{memberCount,number} medlemmer}}',
  'ptc.pm.people': 'Personer',
  'ptc.pm.teams': 'Teams',
  'ptc.pm.view-your-profile': 'Vis din profil',
  'ptc.pm.your-teams.title': 'Dine teams',
};
